import React, { useState, useEffect, useMemo } from "react";
import axios from "../utils/axiosInstance";
import { jsPDF } from "jspdf";

const AkagariIbirego = () => {
  const [ibirego, setIbirego] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const perPage = 10;

  const token = localStorage.getItem("token");
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get("/akagari/ibirego", auth);
        setIbirego(res.data);
      } catch {}
      finally { setLoading(false); }
    })();
  }, []);

  const filtered = useMemo(() =>
    ibirego.filter(r =>
      (r.umwanditsi || "").toLowerCase().includes(search.toLowerCase()) ||
      String(r.id).includes(search)
    ),
    [ibirego, search]
  );
  const totalPages = Math.ceil(filtered.length / perPage);
  const paged = filtered.slice((page - 1) * perPage, page * perPage);
  useEffect(() => { setPage(1); }, [search]);

  const viewDetail = async (id) => {
    try {
      const res = await axios.get(`/akagari/ibirego/${id}`, auth);
      setSelected(res.data);
    } catch {}
  };

  const handlePrintPDF = () => {
    const content = document.getElementById("akagari-print-content");
    if (!content) return;
    const win = window.open("", "_blank");
    win.document.write(`
      <html><head><title>Icyirego</title>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css" rel="stylesheet">
      <style>
        body { font-family: 'Nunito Sans', sans-serif; padding: 2rem; color: #000; background: #fff; }
        .header { text-align: center; margin-bottom: 2rem; border-bottom: 2px solid #000; padding-bottom: 1rem; }
        .header h1 { margin: 0; font-size: 1.5rem; }
        .field { margin-bottom: 1rem; }
        .field-label { font-weight: 700; font-size: 0.85rem; color: #555; }
        .field-value { font-size: 1rem; margin-top: 0.25rem; }
        .signature-block { margin-top: 2rem; border-top: 1px solid #ccc; padding-top: 1rem; }
        .signature-item { margin-bottom: 1.5rem; }
        .signature-item img { max-height: 80px; display: block; }
        .signature-item .name { font-weight: 700; }
        .footer { margin-top: 2rem; font-size: 0.8rem; color: #888; text-align: center; border-top: 1px solid #ccc; padding-top: 1rem; }
        table { width: 100%; border-collapse: collapse; margin-top: 1rem; }
        th, td { padding: 0.5rem; text-align: left; border-bottom: 1px solid #ddd; }
        th { font-weight: 700; color: #555; font-size: 0.85rem; }
        @media print { body { padding: 0.5in; } }
      </style></head><body>
      ${content.innerHTML}
      <div class="footer">Iyi nyandiko yasinywe na buri wese ujyanye n'ikirego</div>
      </body></html>
    `);
    win.document.close();
    setTimeout(() => { win.print(); }, 500);
  };

  const s = {
    card: { background: "var(--surface-2, #141b2d)", border: "1px solid var(--border, #1e2a45)", borderRadius: "12px", padding: "1.5rem" },
    table: { width: "100%", borderCollapse: "collapse" },
    th: { padding: "0.75rem", textAlign: "left", color: "var(--text-soft, #8492a6)", fontSize: "0.75rem", fontWeight: 700, textTransform: "uppercase", borderBottom: "1px solid var(--border, #1e2a45)" },
    td: { padding: "0.75rem", borderBottom: "1px solid var(--border, #1e2a45)", fontSize: "0.85rem", color: "var(--text, #e8edf5)" },
    badge: (c) => ({ display: "inline-block", padding: "0.2rem 0.6rem", borderRadius: "6px", fontSize: "0.7rem", fontWeight: 700, background: c + "22", color: c, border: "1px solid " + c + "44" }),
    btnSmall: { background: "var(--primary, #6c63ff)", border: "none", borderRadius: "6px", color: "#fff", padding: "0.4rem 0.9rem", fontSize: "0.8rem", fontWeight: 600, cursor: "pointer" },
    input: { background: "#0d1322", border: "1px solid #2a3a5c", borderRadius: "8px", color: "#e8edf5", padding: "0.6rem 1rem", width: "100%", maxWidth: 300, outline: "none" },
  };

  if (loading) return <div style={{ color: "var(--text-soft)", textAlign: "center", padding: "3rem" }}>Yegereza...</div>;

  if (selected) {
    const irego = selected;
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem", flexWrap: "wrap", gap: "0.5rem" }}>
          <button onClick={() => setSelected(null)} style={{ ...s.btnSmall, background: "transparent", color: "var(--text-soft)", border: "1px solid var(--border)" }}>
            <i className="bi bi-arrow-left" style={{ marginRight: "0.4rem" }} />Subira
          </button>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <button onClick={handlePrintPDF} style={{ ...s.btnSmall, background: "linear-gradient(135deg,#00d68f,#00b887)" }}>
              <i className="bi bi-download me-1" /> PDF
            </button>
            <button onClick={handlePrintPDF} style={{ ...s.btnSmall, background: "linear-gradient(135deg,#0095ff,#0077cc)" }}>
              <i className="bi bi-printer me-1" /> Print
            </button>
          </div>
        </div>

        <div id="akagari-print-content" style={s.card}>
          <div style={{ textAlign: "center", marginBottom: "2rem", borderBottom: "2px solid var(--primary, #6c63ff)", paddingBottom: "1rem" }}>
            <h2 style={{ color: "#fff", fontWeight: 700, margin: 0 }}>ICYIREGO</h2>
            <p style={{ color: "var(--text-soft, #8492a6)", fontSize: "0.85rem" }}>
              Icyirego cyanditswe ku itariki: {irego.itariki ? new Date(irego.itariki).toLocaleDateString() : "-"}
            </p>
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <div style={{ color: "var(--text-soft, #8492a6)", fontSize: "0.8rem", fontWeight: 600, marginBottom: "0.25rem" }}>
              Umwanditsi w'Icyirego
            </div>
            <div style={{ color: "#fff", fontSize: "1rem" }}>{irego.umwanditsi}</div>
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <div style={{ color: "var(--text-soft, #8492a6)", fontSize: "0.8rem", fontWeight: 600, marginBottom: "0.25rem" }}>
              Ibisobanuro by'Icyirego
            </div>
            <div style={{ color: "var(--text, #b0b9c9)", lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{irego.ibisobanuro}</div>
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <div style={{ color: "var(--text-soft, #8492a6)", fontSize: "0.8rem", fontWeight: 600, marginBottom: "0.25rem" }}>
              Itariki
            </div>
            <div style={{ color: "#fff" }}>{irego.itariki ? new Date(irego.itariki).toLocaleDateString() : "-"}</div>
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <StatusBadge status={irego.status} />
          </div>

          {/* Signatures Section */}
          <div style={{ marginTop: "2rem", borderTop: "1px solid var(--border, #1e2a45)", paddingTop: "1.5rem" }}>
            <h4 style={{ color: "#fff", fontWeight: 600, marginBottom: "1rem" }}>Abasinye:</h4>

            {irego.umutekano_signed_by && (
              <div style={{ marginBottom: "1rem" }}>
                <div style={{ color: "var(--text-soft)", fontSize: "0.8rem", fontWeight: 600 }}>Umuyobozi Ushinzwe Umutekano</div>
                <div style={{ color: "#fff", fontWeight: 600 }}>{irego.umutekano_signed_by}</div>
                {irego.umutekano_signature && (
                  <img src={irego.umutekano_signature} alt="Umukono w'Umutekano"
                    style={{ maxHeight: 60, marginTop: "0.5rem", background: "#fff", borderRadius: 4 }} />
                )}
              </div>
            )}

            {irego.witnesses && irego.witnesses.map((w, i) => (
              <div key={w.id || i} style={{ marginBottom: "1rem" }}>
                <div style={{ color: "var(--text-soft)", fontSize: "0.8rem", fontWeight: 600 }}>Umugabo wa {i + 1}</div>
                <div style={{ color: "#fff", fontWeight: 600 }}>{w.name}</div>
                {w.signature_image && (
                  <img src={w.signature_image} alt={`Umukono wa ${w.name}`}
                    style={{ maxHeight: 60, marginTop: "0.5rem", background: "#fff", borderRadius: 4 }} />
                )}
              </div>
            ))}

            {irego.mudugudu_signed_by && (
              <div style={{ marginBottom: "1rem" }}>
                <div style={{ color: "var(--text-soft)", fontSize: "0.8rem", fontWeight: 600 }}>Umudugudu</div>
                <div style={{ color: "#fff", fontWeight: 600 }}>{irego.mudugudu_signed_by}</div>
                {irego.mudugudu_signature && (
                  <img src={irego.mudugudu_signature} alt="Umukono w'Umudugudu"
                    style={{ maxHeight: 60, marginTop: "0.5rem", background: "#fff", borderRadius: 4 }} />
                )}
              </div>
            )}

            {irego.signatures && irego.signatures.map((sig) => (
              <div key={sig.id} style={{ marginBottom: "1rem" }}>
                <div style={{ color: "var(--text-soft)", fontSize: "0.8rem", fontWeight: 600 }}>{sig.signer_role || sig.signer_name}</div>
                <div style={{ color: "#fff", fontWeight: 600 }}>{sig.signer_name}</div>
                {sig.signature_image && (
                  <img src={sig.signature_image} alt="Umukono"
                    style={{ maxHeight: 60, marginTop: "0.5rem", background: "#fff", borderRadius: 4 }} />
                )}
              </div>
            ))}
          </div>

          {irego.sent_to_kagari_at && (
            <div style={{ marginTop: "1rem", color: "var(--text-soft)", fontSize: "0.8rem" }}>
              <i className="bi bi-check-circle-fill" style={{ color: "var(--success, #00d68f)", marginRight: "0.3rem" }} />
              Yoherejwe mu Kagari: {new Date(irego.sent_to_kagari_at).toLocaleString()}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem", flexWrap: "wrap", gap: "0.5rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
          <i className="bi bi-file-earmark-text" style={{ fontSize: "1.5rem", color: "var(--primary, #6c63ff)" }} />
          <h4 style={{ margin: 0, fontWeight: 700 }}>Ibirego byoherejwe mu Kagari</h4>
        </div>
        <input
          placeholder="Shakisha..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={s.input}
        />
      </div>

      <div style={s.card}>
        <div style={{ overflowX: "auto" }}>
          <table style={s.table}>
            <thead><tr>
              <th style={s.th}>#</th>
              <th style={s.th}>Umwanditsi</th>
              <th style={s.th}>Ibisobanuro</th>
              <th style={s.th}>Itariki</th>
              <th style={s.th}>Abasinye</th>
              <th style={s.th}>Status</th>
              <th style={s.th}>Ibikorwa</th>
            </tr></thead>
            <tbody>
              {paged.length === 0 ? (
                <tr><td colSpan={7} style={{ ...s.td, textAlign: "center", color: "var(--text-soft)" }}>Nta birego byoherejwe mu Kagari</td></tr>
              ) : paged.map((r) => (
                <tr key={r.id}>
                  <td style={s.td}>#{r.id}</td>
                  <td style={s.td}>{r.umwanditsi}</td>
                  <td style={{ ...s.td, maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {r.ibisobanuro}
                  </td>
                  <td style={s.td}>{r.itariki ? new Date(r.itariki).toLocaleDateString() : "-"}</td>
                  <td style={s.td}>
                    <span style={s.badge("#6c63ff")}>
                      {((r.witness_count || 0) + (r.umutekano_signed_by ? 1 : 0) + (r.mudugudu_signed_by ? 1 : 0))}
                    </span>
                  </td>
                  <td style={s.td}><StatusBadge status={r.status} /></td>
                  <td style={s.td}>
                    <button onClick={() => viewDetail(r.id)} style={s.btnSmall}>
                      <i className="bi bi-eye" style={{ marginRight: "0.3rem" }} />Reba
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalPages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", gap: "0.5rem", marginTop: "1rem" }}>
            <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}
              style={{ ...s.btnSmall, opacity: page <= 1 ? 0.5 : 1 }}><i className="bi bi-chevron-left" /></button>
            <span style={{ color: "var(--text-soft)", padding: "0.4rem 0.5rem", fontSize: "0.85rem" }}>{page} / {totalPages}</span>
            <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}
              style={{ ...s.btnSmall, opacity: page >= totalPages ? 0.5 : 1 }}><i className="bi bi-chevron-right" /></button>
          </div>
        )}
      </div>
    </div>
  );
};

const StatusBadge = ({ status }) => {
  const colors = {
    draft: { bg: "rgba(255,170,0,0.1)", color: "#ffaa00" },
    pending: { bg: "rgba(255,170,0,0.1)", color: "#ffaa00" },
    signed: { bg: "rgba(0,214,143,0.1)", color: "#00d68f" },
    sent: { bg: "rgba(0,149,255,0.1)", color: "#0095ff" },
    sent_to_umudugudu: { bg: "rgba(108,99,255,0.1)", color: "#6c63ff" },
    sent_to_akagari: { bg: "rgba(0,214,143,0.15)", color: "#00d68f" },
    mudugudu_signed: { bg: "rgba(0,214,143,0.1)", color: "#00d68f" },
  };
  const s = colors[status] || { bg: "rgba(255,255,255,0.05)", color: "#8492a6" };
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: "0.3rem", padding: "0.25rem 0.6rem",
      borderRadius: 20, fontSize: "0.72rem", fontWeight: 600, background: s.bg, color: s.color,
      border: `1px solid ${s.color}30`,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: s.color }} />
      {status?.replace(/_/g, " ")}
    </span>
  );
};

export default AkagariIbirego;
